import { z } from 'zod'
import { getDuplicatesRefinement } from 'src/util/src/zod'
import { ReferralSystemSchema } from './ReferralSystem'
import { ReferralCodeSchema } from './ReferralCode'

export const ReflinkSchema = z.object({
  system: ReferralSystemSchema,
  code: ReferralCodeSchema,
})

export const ReflinksSchema = z.array(ReflinkSchema)
  .superRefine(getDuplicatesRefinement('Reflink', parseReflinkUid))

export const ReflinkUidSchema = ReflinkSchema.pick({
  system: true,
})

export type Reflink = z.infer<typeof ReflinkSchema>

export type ReflinkUid = z.infer<typeof ReflinkUidSchema>

export function parseReflink(link: Reflink): Reflink {
  return ReflinkSchema.parse(link)
}

export function parseReflinks(links: Reflink[]): Reflink[] {
  return ReflinksSchema.parse(links)
}

export function parseReflinkUid(linkUid: ReflinkUid): ReflinkUid {
  return ReflinkUidSchema.parse(linkUid)
}
